<template>
	<pre v-html="$t('terms.guideline1')"></pre>
</template>

<script>
export default {
	name: 'Guideline1',
};
</script>

<style scoped></style>
